import styled from 'styled-components'
import useMonthlyBookCount from '../hooks/useMonthlyBookCount'
import React from 'react'
import {Chart as ChartJS, CategoryScale, LinearScale, BarElement, Tooltip} from 'chart.js'
import {Bar} from 'react-chartjs-2'
import {useDarkMode} from '../../../../common/hooks/DarkModeContext'
import YearSelectorCard from '../../../../common/styles/YearSelectorCard'
import getBarColors from '../utils/getBarColors'

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip)

const MonthlyCountChart = ({selectedYear}: {selectedYear: number}) => {
	const [data, isLoading] = useMonthlyBookCount(selectedYear)
	const {isDark} = useDarkMode()
	const chartRef = React.useRef<any>(null)

	const months = data?.months ?? []
	const chartData = Array.from({length: 12}, (_, i) => {
		const found = months.find(m => m.month === i + 1)
		return found?.count ?? 0
	})

	const focusOnGreatest = React.useCallback(() => {
		const chart = chartRef.current
		if (!chart || chartData.length === 0) return
		const maxIndex = chartData.lastIndexOf(Math.max(...chartData))
		if (chartData[maxIndex] !== 0) {
			chart.tooltip?.setActiveElements([{datasetIndex: 0, index: maxIndex}], {x: 0, y: 0})
			chart.update()
		}
	}, [chartData])

	React.useEffect(() => {
		focusOnGreatest()
	}, [data])

	return (
		<ChartContainer onMouseLeave={() => setTimeout(focusOnGreatest, 50)}>
			<Bar
				ref={chartRef}
				data={{
					labels: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
					datasets: [{
						data: chartData,
						backgroundColor: getBarColors(chartData),
						borderRadius: 4,
					}],
				}}
				options={{
					animation: isLoading ? false : undefined,
					onHover: (_event, activeElements) => {
						if (activeElements.length === 0) focusOnGreatest()
					},
					plugins: {
						legend: {display: false},
						tooltip: {
							enabled: !isLoading,
							callbacks: {
								label: (context) => `${context.raw}권`,
							},
						},
					},
					scales: {
						x: {
							ticks: {color: isDark ? '#AAA' : '#666'},
							grid: {display: false},
						},
						y: {
							beginAtZero: true,
							ticks: {
								color: isDark ? '#AAA' : '#666',
								stepSize: 1,
							},
							grid: {color: isDark ? '#FFFFFF1A' : '#0000001A'},
						},
					},
					maintainAspectRatio: false,
				}}
			/>
		</ChartContainer>
	)
}

const BookStatisticsMonthlyCountCard = () => {
	return (
		<YearSelectorCard title={'월별 독서 권수'}>
			{(selectedYear) => <MonthlyCountChart selectedYear={selectedYear}/>}
		</YearSelectorCard>
	)
}

const ChartContainer = styled.div`
	height: 270px;
`

export default BookStatisticsMonthlyCountCard
